//ls is loginService
angular.module('careerKeyCentral').directive('messageSentList', function() {
  var directive = {};
  directive.scope = false;
  directive.restrict = 'E'; /* restrict this directive to elements */
  directive.templateUrl = '/app/shared/views/partials/messageSentList.html';
  return directive;
});
